import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { GuestFeedbackBatchDetailsFragmentDoc } from './GuestFeedbackUploadBatchDialog.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GuestFeedbackUploadBatchesQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
}>;


export type GuestFeedbackUploadBatchesQuery = { __typename?: 'Query', GuestFeedbackUploadBatches: { __typename?: 'GuestFeedbackUploadBatches', totalCount: number, objects: Array<{ __typename?: 'GuestFeedbackUploadBatch', id: string, revision: number, status: Types.GuestFeedbackUploadBatchStatus, createdAt: string, files: Array<{ __typename?: 'OrgGuestFeedbackCsvUpload', id: string, fileName?: string | null, status: Types.GuestFeedbackCsvUploadStatus, error?: string | null, importedReviewCount: number, fileUrl: string, feedbackTextColumn: string, feedbackDateColumn: string, ratingColumn: string, ratingColumnMin?: number | null, ratingColumnMax?: number | null, locationColumn: string, feedbackSource?: string | null, locations: Array<{ __typename?: 'OrgGuestFeedbackCsvUploadLocation', id: string, locationName: string, location: { __typename?: 'Location', id: number } }> }>, analysisRun?: { __typename?: 'GuestFeedbackAnalysisRun', id: string, status: Types.GuestFeedbackAnalysisRunStatus, startedAt: string, completedAt?: string | null, error?: string | null } | null }> } };


export const GuestFeedbackUploadBatchesDocument = gql`
    query GuestFeedbackUploadBatches($limit: Int!) {
  GuestFeedbackUploadBatches(pagination: {limit: $limit}) {
    objects {
      ...GuestFeedbackBatchDetails
    }
    totalCount
  }
}
    ${GuestFeedbackBatchDetailsFragmentDoc}`;

/**
 * __useGuestFeedbackUploadBatchesQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackUploadBatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackUploadBatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackUploadBatchesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGuestFeedbackUploadBatchesQuery(baseOptions: Apollo.QueryHookOptions<GuestFeedbackUploadBatchesQuery, GuestFeedbackUploadBatchesQueryVariables> & ({ variables: GuestFeedbackUploadBatchesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackUploadBatchesQuery, GuestFeedbackUploadBatchesQueryVariables>(GuestFeedbackUploadBatchesDocument, options);
      }
export function useGuestFeedbackUploadBatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackUploadBatchesQuery, GuestFeedbackUploadBatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackUploadBatchesQuery, GuestFeedbackUploadBatchesQueryVariables>(GuestFeedbackUploadBatchesDocument, options);
        }
export type GuestFeedbackUploadBatchesQueryHookResult = ReturnType<typeof useGuestFeedbackUploadBatchesQuery>;
export type GuestFeedbackUploadBatchesLazyQueryHookResult = ReturnType<typeof useGuestFeedbackUploadBatchesLazyQuery>;
export type GuestFeedbackUploadBatchesQueryResult = Apollo.QueryResult<GuestFeedbackUploadBatchesQuery, GuestFeedbackUploadBatchesQueryVariables>;